import GridIcon from '@material-ui/icons/TableChart';
import { useEffect, useState } from "react";
import { Button, ReferenceField, useDataProvider, useRedirect } from "react-admin";
import { Route } from 'react-router';
import { BpmnField, Column, Legend, Row } from "../common/components";
import { selectStage } from '../services/project/actions';
import { getStage } from '../services/stage/actions';
import { StageList } from "./Stage";
import { StageInfosForm } from './StageInfos';
import { WorkflowIcon } from "./Workflow";

export const ProjectStages = ({ className, ...props }) => {
    const redirect = useRedirect();
    const dataProvider = useDataProvider();
    const [center, setCenter] = useState("schema");
    const [activity, setActivity] = useState();
    const workflowId = props.record.workflowId;
    useEffect(() => {
        if (activity) {
            getStage(dataProvider, workflowId, activity["element"]["id"]).then((data) => {
                if (data && data.id) {
                    selectStage(redirect, data.id)
                }
            });
        }
    }, [dataProvider, redirect, activity, workflowId]);
    const isSchema = center === "schema";
    return <div className={className}>
        <Row noClone>
            <Column noClone>
                <Row className="stayFlex">
                    <Legend label="resources.project.stages.legend" variant="h4" />
                    <Button variant="contained" label={isSchema ? "resources.project.showGrid" : "resources.project.showSchema"} onClick={() => {
                        setCenter(isSchema ? "grid" : "schema");
                    }}>{isSchema ? <GridIcon /> : <WorkflowIcon />}</Button>
                </Row>
                <StageList hideDetails filter={{ workflowId: props.record.workflowId }} style={{ display: isSchema ? "none" : "block" }} rowClick={(id) => {
                    selectStage(redirect, id);
                }} />
                <ReferenceField addLabel={false} link="" source="workflowId" reference="workflow">
                    <BpmnField style={{ display: isSchema ? "block" : "none" }} source="model" className="stages" onActivityClick={(e) => { setActivity(e); }} />
                </ReferenceField>
            </Column>
            <Route exact path="/project/:id/stage/:stageId">
                {({ match }) => {
                    if (match) {
                        return <StageInfosForm projectId={match.params.id} stageId={match.params.stageId} projectRecord={props && props.record} />;
                    } else {
                        return <span style={{ display: "none" }}></span>;
                    }
                }}
            </Route>
        </Row>
    </div>
};